import {createStore} from "effector";

export const $regReqStatus = createStore(false)

export const $requestsList = createStore([])

export const $selectedRequestModal = createStore({visible: false, id: null})
export const $selectedRequestInfo = createStore(null)